module.exports = __webpack_public_path__ + "media/images/Logo-b9b15cbd6ea0b201761e8ed5ac637d63.svg";